/* eslint-disable react/no-deprecated */
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import { App } from "./container";
// import "resources/styles/scss/main.scss";
import { Provider } from "react-redux";
import { configuredStore } from "./store/index";
import "../src/resources/styles/scss/main.scss";
//import { CookiePolicy } from "components/_ui";
// import 'swiper/css/swiper.css';

export const store = configuredStore();
const container = document.getElementById("root");

const app = (
  <Provider store={store}>
    <App />
    {/* <CookiePolicy /> */}
  </Provider>
);

// react-snap pre-renders each route to static HTML at build time.
// If that HTML is already sitting inside #root when this script runs,
// hydrate it instead of wiping it and rendering from scratch.
// Regular local dev (no pre-rendered content) falls through to createRoot
// exactly as before.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  const root = createRoot(container);
  root.render(app);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// testing shit